module.exports = __webpack_public_path__ + "img/slide3-mb.06b9d390.png";